// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".admin-page-content {\n  --ion-background-color: var(--ion-color-light);\n}\n\n.admin-page-content ion-item-group {\n  --ion-background-color: #fff;\n}\n\n.group-access-request-list-label {\n  font-size: 18px !important;\n}\n\nion-item-group + ion-item-group {\n  margin-top: 20px;\n}\n\n.toast-wrapper.toast-bottom {\n  bottom: 55px;\n}\n\nion-item-group {\n  max-width: 600px;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
